<template>
    <div class="w-full max-w-[1120px] h-full">
        <RouterView />
    </div>
</template>
